/**
 * 最终订货接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const api = {
    //页面初始化
    init() {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills/inittemplate`);
    },
    //检索数据
    search(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills` ,{ params: params});
    },
    //根据检索条件 得到 已审核数据条数
    auditNumber(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills/audit-number` ,{ params: params});
    },
    //转账通知单查询-转账单查询-审核
    auditPass(params) {
      return axios.put(`${Vue.prototype.$base.API_PATH}/transferbills/audit/pass`,params);
    },
    //转账通知单查询-转账单查询-取消审核
    cancelAudit(params) {
      return axios.put(`${Vue.prototype.$base.API_PATH}/transferbills/audit/cancel`,params);
    },
    //转账通知单查询-转账单查询-根据传票号取得转账通知单明细数据
    dataByPoNumNew(poNumNew) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills/po-num-new/`+poNumNew);
    },
    //转账通知单查询-转账单查询-根据明细单号取得转账明细数据
    dataByPoNum(poNum,params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills/po-num/`+poNum,{ params: params});
    },
    //打印数据获取
    print(poNum,params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/transferbills/po-num/print/`+poNum ,{ params: params});
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/api/transferbills.js